/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 09:49:15
 * @Explain: 关于存储的封装
 */
import type { StoreKeyEnum } from '@/definition/common/data.d';
import { isArray, isObject } from '@/utils/common/dataJudgment';
import type jsonBig from 'json-bigint';

export function jsonParse(data: any, type: string = 'default') {
  let parseObj = null;
  try {
    if (data) {
      if (type === 'big') {
        parseObj = jsonBig.parse(data); // 用于有较大数字的方法
      } else {
        parseObj = JSON.parse(data);
      }
    }
  } catch (e) {
    console.error(e);
  }
  return parseObj;
}

export function jsonStringify(data: any, type: string = 'default') {
  let parseObj = null;
  try {
    if (type === 'big') {
      parseObj = jsonBig.stringify(data); // 用于有较大数字的方法
    } else {
      parseObj = JSON.stringify(data);
    }
  } catch (e) {
    console.error(e);
  }
  return parseObj;
}

export function setLocalStorage(key: StoreKeyEnum, value: any) {
  window.localStorage.setItem(
    key,
    isObject(value) || isArray(value) ? jsonStringify(value) : value,
  );
}

export function getLocalStorage(key: StoreKeyEnum) {
  return window.localStorage.getItem(key);
}

export function removeLocalStorage(key: StoreKeyEnum) {
  return window.localStorage.removeItem(key);
}

/** 存储Sesstion */
export const setSessionStorage = (params: any) => {
  const { name, content } = params;
  window.sessionStorage.setItem(name, JSON.stringify({ content }));
};
/** 获取Sesstion */
export const getSessionStorage = (name: StoreKeyEnum) => {
  let data: any = window.sessionStorage.getItem(name);
  try {
    data = data && JSON.parse(data);
  } catch (e) {
    console.error('getSessionStorage=>>', e);
  }
  return data?.content;
};
/** 删除Sesstion */
export const removeSessionStorage = (key: StoreKeyEnum) => {
  window.sessionStorage.removeItem(key);
};
